import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Review from '../Review';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';
import { Link } from '@zocdoc/components/src/link';
import { kievitSlabBook } from '@zocdoc/components/src/typography';
import { LOCALIZED_STRINGS } from '../constants';
import Button from '@zocdoc/components/src/button';

export default class ReviewsBody extends PureComponent {
    static propTypes = {
        reviews: PropTypes.array.isRequired,
        showAll: PropTypes.bool.isRequired,
        defaultNumberOfReviews: PropTypes.number.isRequired,
    }

    scrollToTop = () => {
        const { clickBackToTop } = this.props;
        clickBackToTop();
        window.scrollTo(0, 0);
    }


    renderReviews(reviews) {
        return reviews.map((review, index) => (
            <Review
                key={index}
                {...review}
            />
        ));
    }

    renderPatientReviews() {
        const {
            showAll,
            defaultNumberOfReviews,
            reviews = [],
        } = this.props;
        if (showAll || reviews.length <= defaultNumberOfReviews) {
            return this.renderReviews(reviews);
        } else {
            const defaultReviews = reviews.slice(0, defaultNumberOfReviews);
            return this.renderReviews(defaultReviews);
        }
    }

    maybeRenderShowMoreButton() {
        const {
            showAll,
            showMoreReviews,
            defaultNumberOfReviews,
            reviews = [],
        } = this.props;

        // We currently don't have a way of determining how many reviews a doctor has.
        // If the number of reviews is equal to the max number to show on page load,
        // assume that we didn't fetch all the reviews, and show the "show more" button.
        // TODO: get the actual number of doctor reviews, and use the actual number to determine
        // whether or not to show the "show more" button
        if (!showAll && reviews.length >= defaultNumberOfReviews) {
            return (
                <ReviewButton
                    data-test="show-more-button"
                    onClick={showMoreReviews}
                >
                    <ButtonText>
                        <FormattedMessage {...LOCALIZED_STRINGS.ShowMoreReviews} />
                    </ButtonText>
                </ReviewButton>
            );
        }
    }

    render() {
        return (
            <ReviewsBodyContainer>
                <div>
                    {this.renderPatientReviews()}
                </div>
                <ButtonWrapper>
                    {this.maybeRenderShowMoreButton()}
                </ButtonWrapper>
                <ButtonWrapper>
                    <Button
                        data-test="back-to-top-button"
                        onClick={this.scrollToTop}
                        style={Button.STYLE.SCROLL_UP_ARROW}
                    >
                        <FormattedMessage {...LOCALIZED_STRINGS.BackToTop} />
                    </Button>
                </ButtonWrapper>
            </ReviewsBodyContainer>
        );
    }
}

const ReviewsBodyContainer = styled.div`
    padding-top: 25px;
`;

const ReviewButton = styled(Link)`
    display: inline-block;
    margin: 8px 0 28px;
    padding: 0;
`;

const ButtonText = styled.div`
    ${kievitSlabBook(14, 20)};
    ${breakpoint.medium} {
        ${kievitSlabBook(18, 22)};
    }
`;

const ButtonWrapper = styled.div`
    clear: both;
`;
